import React from "react";

const FloatingLabelInput = ({
  type,
  placeholder,
  register,
  name,
  rules,
  errors,
  onChange,
  disabled,
  nameInput,
  value,
  inputRef,
  defaultValue,
  inputClassName = "",
  wrapperClassName = "",
  handleKeyDown = () => {},
  onFocus,
  onBlur,
  autoComplete,
}) => {
  return (
    <div className="input-group__wrapper">
      <div className={`${wrapperClassName} input-group`}>
        <label className="input-group__label" htmlFor={type}>
          <input
            onKeyDown={handleKeyDown}
            onChange={onChange}
            name={type}
            type={type}
            placeholder={placeholder}
            className={["input-group__input"].join(" ")}
            disabled={disabled}
            {...(value && { value })}
            {...(inputRef && { ref: inputRef })}
            {...(defaultValue && { defaultValue })}
            {...(register && register(name, rules))}
            {...(onFocus && { onFocus })}
            {...(onBlur && { onBlur })}
            {...(autoComplete && { autoComplete })}
          />
          <span className="input-group__span">{placeholder}</span>
        </label>
      </div>
      {errors && errors[name]?.message && (
        <span className="input-group__error">{errors[name]?.message}</span>
      )}
    </div>
  );
};

export default FloatingLabelInput;
